import { LOAD_ORDERS_REQUEST, LOAD_ORDERS_SUCCESS, LOAD_ORDERS_ERROR, } from '../types';
import { useHelper } from '../helpers';
export const loadOrdersRequest = () => ({
    type: LOAD_ORDERS_REQUEST,
});
export const loadOrdersSuccess = (data) => ({
    type: LOAD_ORDERS_SUCCESS,
    payload: { data },
});
export const loadOrdersError = (error) => ({
    type: LOAD_ORDERS_ERROR,
    payload: error,
    error: true,
});
export const loadOrders = (options) => async (dispatch, getState, { chord }) => {
    const { withAuth } = useHelper(dispatch, getState);
    dispatch(loadOrdersRequest());
    try {
        const { orders } = await withAuth(chord.oms.getUserOrders)(options?.includeDetails);
        dispatch(loadOrdersSuccess(orders));
        return orders;
    }
    catch (error) {
        dispatch(loadOrdersError(error));
        throw error;
    }
};
